<template>
  <a-modal :title="readonly ? '查看会员信息' : form.member_id ? '修改会员信息' : '新增会员信息'" :visible="visible"
    :confirm-loading="confirmLoading" :ok-button-props="{ props: { disabled: readonly } }" cancelText="关闭"
    @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="会员级别" prop="vip_key">
        <a-select :disabled="readonly" v-model="form.vip_key" style="width: 100%" placeholder="请选择" @change="changeVip">
          <a-select-option v-for="v in vipList" :key="v.vip_name" :value="v.vip_name" :label="v.vip_name">
            {{ v.vip_name }}
            <!-- ({{ v.vip_price }}) -->
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="'缴费收款账户'" prop="account_id">
        <a-select v-model="form.account_id" show-search :filter-option="filterOption" placeholder="请选择" style="width: 100%" :disabled="readonly">
          <a-select-option v-for="item in accountList" :key="item.account_id" :value="item.account_id">
            {{ item.account_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="缴费金额" prop="pay_price">
        <a-input-number :disabled="readonly" v-model="form.pay_price" :min="0" :step="0.01" style="width: 100%"
          placeholder="请输入缴费金额" />
      </a-form-model-item>
      <a-form-model-item label="缴费时间" prop="pay_time">
        <a-date-picker :disabled="readonly" show-time style="width: 100%;" :format="'YYYY/MM/DD HH:mm:ss'"
          :valueFormat="'YYYY/MM/DD HH:mm:ss'" v-model="form.pay_time" />
      </a-form-model-item>
      <a-form-model-item label="会员有效性" prop="enable">
        <a-radio-group v-model="form.enable" :disabled="readonly">
          <a-radio value="1">
            有效
          </a-radio>
          <a-radio value="2">
            无效
          </a-radio>
          <a-radio value="3">
            退会
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="入会福利" prop="pay_benefit">
        <a-textarea :disabled="readonly" v-model="form.pay_benefit" placeholder="请输入会员入会给予的权益或福利"
          :auto-size="{ minRows: 2, maxRows: 6 }" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea :disabled="readonly" v-model="form.remark" placeholder="会员备注"
          :auto-size="{ minRows: 2, maxRows: 6 }" />
      </a-form-model-item>
      <a-form-model-item label="入会操作人" prop="user_id" v-permission="['admin:member:changeuser']">
        <a-select v-model="form.user_id" :disabled="readonly" style="width: 100%" placeholder="请选择(不填默认为当前登录用户)"
          option-label-prop="label" :filter-option="filterOption">
          <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
            {{ v.real_name }}
            <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
              ({{ v.department.department_name }})
            </span>
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      readonly: false,
      visible: false,
      confirmLoading: false,
      form: {
        member_id: "",
        customer_id: "",
        vip_key: undefined,
        account_id: undefined,
        pay_price: "",
        pay_time: "",
        enable: "1",
        pay_benefit: "",
        remark: "",
        user_id: undefined
      },
      rules: {
        vip_key: [
          {
            required: true,
            message: "请选择会员级别",
            trigger: "blur",
          },
        ],
        account_id: [
          {
            required: true,
            message: "请选择缴费收款账户",
            trigger: "change",
          },
        ],
        pay_price: [
          {
            required: true,
            message: "请输入缴费金额",
            trigger: "blur",
          },
        ],
        pay_time: [
          {
            required: true,
            message: "请选择缴费时间",
            trigger: "change",
          },
        ],
        enable: [
          {
            required: true,
            message: "请选择会员有效性",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      vipList: [],
      userList: [],
      accountList: []
    };
  },
  methods: {
    init({ member_id, customer_id, readonly = false }) {
      this.visible = true;
      this.readonly = readonly
      this.form.member_id = member_id;
      if (customer_id) {
        this.form.customer_id = customer_id;
      }
      if (member_id) {
        this.$http({
          url: "/admin/member/info",
          method: "post",
          data: {
            id: member_id,
          },
        }).then((res) => {
          this.form = { ...res.data }
        });
      }
      this.getVipList();
      this.getUserList();
      this.getAccountList();
    },
    getAccountList() {
      this.$http({
        url: "/admin/account/select",
        method: "get",
      }).then(res => {
        this.accountList = res.data
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    changeVip(e) {
      const a = this.vipList.find(v => v.vip_name == e)
      if (!this.form.member_id) {
        this.form.pay_price = a.vip_price
        this.form.pay_benefit = a.benefit
      }
    },
    getVipList() {
      this.$http({
        url: "/admin/viplist/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.vipList = res.data.result;
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.member_id
              ? "/admin/member/update"
              : "/admin/member/create",
            method: "post",
            data: {
              ...this.form,
            },
          })
            .then(() => {
              this.$message.success(
                this.form.member_id ? "修改成功" : "创建成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style></style>